<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot-scope="title">
          <p class="text-wrap">{{title}}</p>
        </template>
        <template slot-scope="description">
          <p class="text-wrap">{{description}}</p>
        </template>
        <template slot="due_date" slot-scope="due_date">
          <p class="text-wrap">{{moment(due_date).format('DD-MM-YYYY')}}</p>
        </template>
        <template slot="created_at" slot-scope="created_at">
          <p class="text-wrap">{{moment(created_at).format('DD-MM-YYYY HH:m A')}}</p>
        </template>
        <template slot="created_by" slot-scope="created_by">
          <p class="text-wrap">{{created_by.first_name + ' ' +created_by.last_name}}</p>
        </template>
        <template slot="action" slot-scope="record">
          <div class="text-nowrap">
            <a-tooltip
              placement="top"
              title="View Homework"
            >
              <a href="javascript:" class="btn btn-sm btn-info mr-2" v-if="rolesetting.viewable" @click="showViewModal(record)">
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-eye" />
              </span>
              </a>
            </a-tooltip>

            <a-tooltip
              placement="top"
              title="Edit Homework"
            >
              <a href="javascript:" class="btn btn-sm btn-primary mr-2" v-if="rolesetting.editable" @click="showEditModal(record)">
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
              </a>
            </a-tooltip>

            <a-tooltip
              placement="top"
              title="Delete Homework"
            >
              <a href="javascript:" class="btn btn-sm btn-danger" v-if="rolesetting.deletable"  @click="handleDelete(record)">
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
              </a>
            </a-tooltip>
          </div>
        </template>
      </a-table>
    </div>
    <edit-homework @updateTable="handleAfteredit" />
    <view-homework @updateTable="handleAfteredit"/>
  </div>
</template>

<script>
import EditHomework from '@/components/homework/Edit/index'
import ViewHomework from '@/components/homework/View/index'

import moment from 'moment'

const columns = [
  { title: 'Title', dataIndex: 'title', width: '200px', scopedSlots: { customRender: 'title' } },
  { title: 'Class', dataIndex: 'school_class.name', scopedSlots: { customRender: 'school_class.name' } },
  { title: 'Section', dataIndex: 'section.name', scopedSlots: { customRender: 'section.name' } },
  { title: 'Subject', dataIndex: 'subject.name', scopedSlots: { customRender: 'subject.name' } },
  { title: 'Due Date', dataIndex: 'due_date', scopedSlots: { customRender: 'due_date' } },
  { title: 'Created At', dataIndex: 'created_at', scopedSlots: { customRender: 'created_at' } },
  { title: 'Created By', dataIndex: 'created_by', scopedSlots: { customRender: 'created_by' } },
  { title: 'Actions', className: 'text-right', scopedSlots: { customRender: 'action' } },
]

export default {
  name: 'HomeworkTable',
  components: {
    EditHomework,
    ViewHomework,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    rolesetting: { type: Object },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      columns,
    }
  },
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    moment,
    showViewModal(record) {
      this.$eventBus.$emit('openViewForm', record)
    },
    showEditModal(record) {
      this.$eventBus.$emit('openEditForm', record)
    },
    handleAfteredit() {
      this.$emit('updateTable')
    },
    handleDelete(record) {
      this.$confirm({
        title: 'Are you sure to delete this record?',
        content: 'Clicking yes will delete this homework.',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/homework/' + record.id)
            .then((resp) => {
              // this.$emit('updateTable')
              if (resp.status === 200) {
                this.$emit('updateTable') // Reload the table
                this.$nprogress.done()

                this.$notification['success']({
                  message: 'Deleted Successfully!',
                  description: 'The homework has been deleted.',
                })
              } else {
                this.$notification['warning']({
                  message: 'Unknown Error',
                  description: 'There appears to be an error while submitting data. Please try again later.',
                })
              }
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },

}
</script>

<style>

</style>
